import prop from 'ramda/src/prop'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import stepIdSelector from 'root/src/client/logic/form/selectors/stepIdSelector'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

const { viewSteps } = formModuleLenses

export default (
	state, { moduleKey },
) => {
	const moduleId = moduleIdFromKey(moduleKey)
	const stepId = stepIdSelector(state, { moduleKey })
	return prop(stepId, viewSteps(moduleId, moduleDescriptions))
}
